import * as React from 'react';
import { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';
import Overlay from "react-overlay-component";
import firebase from "gatsby-plugin-firebase"
import useUser from "../hooks/useUser"

import styles from "../styles/calendar.module.css"

const Frame = styled.div`
  width: auto;
  border: 1px solid lightgrey;
  box-shadow: 2px 2px 2px #eee;
  margin:auto;
`;

const Header = styled.div`
  font-size: 18px;
  font-weight: bold;
  padding: 10px 10px 5px 10px;
  display: flex;
  justify-content: space-between;
  background-color: #f5f6fa;
`;

const Button = styled.div`
  cursor: pointer;
`;

const Body = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
`;

const Day = styled.div`
  width: 14.2%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  :hover {
    background-color: #f5f6fa; 
    cursor: pointer;
  }
  ${props =>
    props.isToday &&
    css`
      border: 1px solid #eee;
    `}
  ${props =>
    props.moodColor &&
    css`
      background-color: ` + props.moodColor + `;
    `}
  
`;

/*
  ${props =>
    props.isSelected &&
    css`
      background-color: #eee;
    `}
    */

function getColor(journal_entry) {
  let sentiment_score = journal_entry.sentimentScore;
  let sentiment_magnitude = journal_entry.sentimentMagnitude;
  let new_sentiment_color = (-sentiment_score + 1) * 90;
  let new_magnitude_color = Math.min(sentiment_magnitude * 90, 90);
  return "hsl(" + new_sentiment_color + ", " + new_magnitude_color + "%, 75%)";
}

function getMoodColor(sentimentScore, sentimentMagnitude) {
  let new_sentiment_color = (-sentimentScore + 1) * 90;
  let new_magnitude_color = Math.min(sentimentMagnitude * 90, 90);
  return "hsl(" + new_sentiment_color + ", " + new_magnitude_color + "%, 70%)";
}

export default (props) => {
  const user = useUser()
  const [calendarColors, setCalendarColors] = useState({})
  const [userJournals, setUserJournals] = useState({})
  const [selectedJournal, setSelectedJournal] = useState()

  useEffect(() => {
    if (user) {
      const db = firebase.firestore()
      console.log(user.uid)

      var user_calendar_colors = {};
      var userJournalData = {};
      db.collection('users').doc(user.uid).collection('journals').get().then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const journal = doc.data();

          console.log("DATA", doc.data())

          const entry_color = getColor(journal);
          const date_created = journal.created.toDate()


          console.log("JOURNAL SENTIMENT SCORE ", journal.sentimentScore)
          console.log(date_created);
          console.log(entry_color)

          user_calendar_colors[date_created] = entry_color;
          userJournalData[date_created] = doc.data();

        })
      })
      setCalendarColors(user_calendar_colors)
      setUserJournals(userJournalData);

    }
  }, [user])

  const [isOpen, setOverlay] = useState(false);
  const closeOverlay = () => setOverlay(false);

  const configs = {
    animate: true,
    // clickDismiss: false,
    // escapeDismiss: false,
    // focusOutline: false,
  };

  const DAYS = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  const DAYS_LEAP = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  const DAYS_OF_THE_WEEK = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
  const MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

  const today = new Date();
  const [date, setDate] = useState(today);
  const [day, setDay] = useState(date.getDate());
  const [month, setMonth] = useState(date.getMonth());
  const [year, setYear] = useState(date.getFullYear());
  const [startDay, setStartDay] = useState(getStartDayOfMonth(date));

  useEffect(() => {
    setDay(date.getDate());
    setMonth(date.getMonth());
    setYear(date.getFullYear());
    setStartDay(getStartDayOfMonth(date));
  }, [date]);

  function getStartDayOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth(), 1).getDay();
  }

  function isLeapYear(year, number) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  }

  function findMoodOfDay(day) {
    for (var journal_day in userJournals) {
      const journal_date_info = new Date(journal_day)
      if (journal_date_info.toDateString() === day.toDateString()) {
        return getColor(userJournals[journal_day]);   
      }
    }

    return "#FFFFFF"
  }


  const days = isLeapYear ? DAYS_LEAP : DAYS;

  console.log("SELECTED JOURNAL", selectedJournal);
  const colored_sentences = (selectedJournal) ? selectedJournal.sentenceSentiment.map(
    (sentence) => {
        const moodColor = getMoodColor(sentence.sentiment.score, sentence.sentiment.magnitude);
        return <span className={styles.spantext} style={{ color: moodColor }}>{sentence.text.content ? sentence.text.content : ""}</span>
    }
  ) : <p>No Journal entry found for this day!</p>


  return (
    <>
      <Frame>
        <Header>
          <Button onClick={() => setDate(new Date(year, month - 1, day))}>Prev</Button>
          <div>
            {MONTHS[month]} {year}
          </div>
          <Button onClick={() => setDate(new Date(year, month + 1, day))}>Next</Button>
        </Header>
        <Body>
          {DAYS_OF_THE_WEEK.map(d => (
            <Day key={d}>
              <strong>{d}</strong>
            </Day>
          ))}
          {Array(days[month] + (startDay - 1))
            .fill(null)
            .map((_, index) => {
              const d = index - (startDay - 2);
              return (
                <Day
                  key={index}
                  isToday={d === today.getDate()}
                  isSelected={d === day}
                  moodColor={ findMoodOfDay(new Date(year, month, d)) }
                  onClick={() => {
                    setDate(new Date(year, month, d))
                    console.log("SEARCHING")
                    var selected_day_has_journal = false;
                    for (var journal_day in userJournals) {
                      const journal_date_info = new Date(journal_day)
                      if (journal_date_info.toDateString() === new Date(year, month, d).toDateString()) {
                        setSelectedJournal(userJournals[journal_day])     
                        selected_day_has_journal = true;                   
                      }
                    }
                    
                    if (!selected_day_has_journal) setSelectedJournal()
                    setOverlay(true);
                  }}
                >
                  {d > 0 ? d : ''}
                </Day>
              );
            })}
        </Body>
      </Frame>

      
    <div>
      <Overlay configs={configs} isOpen={isOpen} closeOverlay={closeOverlay}>
      {(selectedJournal) ? ((selectedJournal.header) ? <h1 style={{ color : getColor(selectedJournal) }}>{selectedJournal.header}</h1> : <h1>Untitled</h1>) : <h1>Nothing here!</h1> }
      <h2>{date.toDateString()}</h2>
      {colored_sentences}
      </Overlay>
    </div>
    </>
  );
}


// import React from "react"
// import { useState, useEffect } from "react"
// import Calendar from 'react-calendar'

// import styles from "../styles/calendar.module.css"
// import "../components/journal"
// import firebase from "gatsby-plugin-firebase"
// import useUser from "../hooks/useUser"

// import moment from 'moment'

// weekdayshort = moment.weekdaysShort();
// let weekdayshortname = this.weekdayshort.map(day => {
//     return (
//       <th key={day} className="week-day">
//        {day}
//       </th>
//     );
//  });


// export default (props) => {
//     const user = useUser()
//     const [calendarColors, setCalendarColors] = useState({})
//     const [date, setDate] = useState(new Date())

//     function sameDay(d1, d2) {
//         return d1.getFullYear() === d2.getFullYear() &&
//           d1.getMonth() === d2.getMonth() &&
//           d1.getDate() === d2.getDate();
//       }

//     function getColor(journal_entry) {
//         let sentiment_score = journal_entry.sentimentScore;
//         let sentiment_magnitude = journal_entry.sentimentMagnitude;
//         let new_sentiment_color = (-sentiment_score + 1) * 90;
//         let new_magnitude_color = Math.max(sentiment_magnitude * 100);
//         return "hsl(" + new_sentiment_color + ", " + new_magnitude_color + "%, 75%)";
//     }

//     useEffect(()=>{
//         if(user){
//             const db = firebase.firestore()
//             console.log(user.uid)

//             var user_calendar_colors = {};
//             db.collection('users').doc(user.uid).collection('journals').get().then(querySnapshot => {
//                 querySnapshot.forEach(doc => {
//                     const journal = doc.data();

//                     console.log("DATA", doc.data())

//                     const entry_color = getColor(journal);
//                     const date_created = journal.created.toDate()


//                     console.log("JOURNAL SENTIMENT SCORE ", journal.sentimentScore)
//                     console.log(date_created);
//                     console.log(entry_color)

//                     user_calendar_colors[date_created] = entry_color;


//                     {/*
//                     changeCalendarDate(toDateTime(journal.created.seconds))
//                     console.log("DATE", toDateTime(journal.created.seconds))

//                     calendarColors.calendarDate = getColor()
//                 */}

//                 })
//             })

//             setCalendarColors(user_calendar_colors)

//         }
//     },[user])

//     console.log("CALENDAR COLORS", calendarColors);

//     const tileContent = ({ date, view }) => {
//         for (var day in calendarColors) {
//             if (sameDay(new Date(day), date)) {
//                 console.log("DETECTED DATE")
//                 console.log("calendarcolors", calendarColors[day])
//                 return <div className="moodTile" style={{ backgroundColor : calendarColors[day] }}><span/></div>
//             }
//         }
//         return null;
//         return view === 'month' && date.getDay() === 0 ? <p>Sunday!</p> : null;
//     }
//     return(
//         <>
//         <div class = "cal">
//             <Calendar 
//                 className = "react-calendar"
//                 tileContent={tileContent}
//             />
//         </div>
//         </>
//     )

//     {/*

//     */}
// }